import { Registry } from 'vscode/vscode/vs/platform/registry/common/platform';
import { Extensions } from 'vscode/vscode/vs/workbench/common/contributions';
import { RemoteStartEntry } from './remoteStartEntry.js';

( Registry.as(Extensions.Workbench))
    .registerWorkbenchContribution(RemoteStartEntry, 3 );
